import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the ProTeam and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'هنا هيكتب أراء الناس سواء بالعربي أو بالإنجليزي زي " دكتور محمد كان من الناس الي ساعدتني أتقدم كتير في حياتي ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:'كل شخص مع الصورة الخاصة بيه ',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
